import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10",
  height: "12",
  viewBox: "0 0 10 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 0C5.41421 0 5.75 0.335786 5.75 0.75L5.75 6.68934L7.46967 4.96967C7.76256 4.67678 8.23744 4.67678 8.53033 4.96967C8.82322 5.26256 8.82322 5.73744 8.53033 6.03033L6.23744 8.32322C5.55402 9.00664 4.44598 9.00664 3.76256 8.32322L1.46967 6.03033C1.17678 5.73744 1.17678 5.26256 1.46967 4.96967C1.76256 4.67678 2.23744 4.67678 2.53033 4.96967L4.25 6.68934V0.75C4.25 0.335786 4.58579 0 5 0ZM0.75 10.5C0.335786 10.5 0 10.8358 0 11.25C0 11.6642 0.335786 12 0.75 12H9.25C9.66421 12 10 11.6642 10 11.25C10 10.8358 9.66421 10.5 9.25 10.5H0.75Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }